<script lang='javascript'>
import Navbar from '../../components/Navbar';
import ProfileNavbar from '../../components/ProfileNavbar';
import Loader from '../../components/Loader';

export default {
    components: {Navbar, ProfileNavbar, Loader},


    data() {
        return {
            isLoading: false,
        }
    },

    mounted() {
        
    },

    created: function() {

    },

    methods: {
    }

}
</script>


<template lang='pug'>
.page-wrapper
    Navbar
    ProfileNavbar
    .profile-wrapper
        router-view
</template>

<style lang='stylus' scoped>
@import "../../../stylus/mixins";
.page-wrapper
    width: 100%
    display-flex column

.profile-wrapper
    display-flex(column)
    align-self center

    border-radius: 10px;

    width 80%
    background-color white
    margin-top 50px;

    @media (max-width: 1000px) 
        width: 95%
</style>

